import { useEffect, useState } from "react";
import { ExternalLink, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export const TeleconsultPaymentCard = ({ appointmentId, dark = false }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get(`/appointments/${appointmentId}/payment`).then(({ data }) => setInfo(data)).catch(() => {});
  }, [appointmentId]);

  if (!info || (!info.payment_link && !info.payment_instructions)) return null;
  const base = dark ? "bg-slate-800 border-slate-700 text-white" : "bg-white border-slate-200 text-deep";
  return (
    <div className={`border rounded-xl p-4 flex flex-wrap items-center justify-between gap-3 ${base}`} data-testid="teleconsult-payment-card">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-[#FF7A5C]/15 text-[#FF7A5C] flex items-center justify-center"><Wallet className="h-4 w-4" /></div>
        <div>
          <div className="font-display font-bold text-sm">Régler la téléconsultation · {info.consultation_fee} €</div>
          <div className={`text-xs ${dark ? "text-slate-300" : "text-slate-500"}`}>
            Paiement direct à {info.doctor_name} — Doctobook ne perçoit rien.
            {info.payment_instructions && <> {info.payment_instructions}</>}
          </div>
        </div>
      </div>
      {info.payment_link && (
        <a href={info.payment_link} target="_blank" rel="noreferrer">
          <Button className="btn-coral font-bold" data-testid="teleconsult-pay-btn">Payer {info.consultation_fee} € <ExternalLink className="h-3.5 w-3.5 ml-1.5" /></Button>
        </a>
      )}
    </div>
  );
};
